// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import VueFormWizard from 'vue-form-wizard'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import es from 'vee-validate/dist/locale/es'
import * as VeeValidate from 'vee-validate'
import { Validator } from 'vee-validate'
import PeticionForm from '@/components/PeticionForm'
import Login from '@/components/Login'
import Register from '@/components/Register'

Vue.use(VueFormWizard)
Validator.localize('es', es)
Vue.use(VeeValidate, {inject: true, errorBagName: 'errors', locale: 'es'})

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: {
    'baseapp': App,
    'peticionform': PeticionForm,
    'login': Login,
    'register': Register
  }
})



// WEBPACK FOOTER //
// ./src/main.js